/**
 * Auth Guard Component
 * Protect routes that require authentication
 */

import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { useAuthStore } from '../../store/authStore';
import Loading from '../common/Loading';
import { colors } from '../../theme/colors';

interface AuthGuardProps {
  children: React.ReactNode;
  navigation?: any;
}

export default function AuthGuard({ children, navigation }: AuthGuardProps) {
  const { isAuthenticated, isLoading } = useAuthStore();

  // NOTE: checkAuth() is already called in App.tsx on mount
  // Calling it here causes a race condition that overwrites successful setAuth()
  // Removed the redundant checkAuth() call

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      // Redirect to login if not authenticated
      navigation?.navigate('Login');
    }
  }, [isLoading, isAuthenticated, navigation]);

  if (isLoading) {
    return (
      <View style={styles.container}>
        <Loading message="Vérification de l'authentification..." />
      </View>
    );
  }

  if (!isAuthenticated) {
    // Show loading state while navigation occurs instead of null
    return (
      <View style={styles.container}>
        <Loading message="Redirection..." />
      </View>
    );
  }

  return <>{children}</>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.background,
  },
});

